import styled from "@emotion/styled";
import {
	alertClasses,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	paperClasses
} from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
	[`.${paperClasses.root}`]: {
		borderRadius: `${theme.project.borders.radius.large}px`,
		minHeight: "600px",
		maxWidth: "700px"
	}
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
	...theme.project.typography.heading.h6,
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	padding: theme.project.layout.gutters.large,
	color: theme.project.colors.fontColors.main
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
	padding: theme.project.layout.gutters.large,
	display: "flex",
	flexDirection: "column",
	gap: theme.project.layout.gap.large,
	[`& .${alertClasses.root}`]: {
		marginBottom: "16px",
		height: "38px",
		minHeight: "auto",
		borderRadius: 0
	}
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
	padding: theme.project.layout.gutters.large,
	borderTop: theme.project.borders.presets.thinOutline,
	gap: theme.project.layout.gap.medium,
	justifyContent: "flex-end"
}));

export const RequiredFieldNotice = styled("div")(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));

export const SectionContainer = styled("div")({
	display: "flex",
	flexDirection: "column"
});

export const SectionTitle = styled("h3")(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	marginTop: 0,
	marginBottom: theme.project.layout.gap.small,
	color: theme.project.colors.fontColors.main
}));

export const SectionDescription = styled("p")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	marginTop: 0,
	marginBottom: theme.project.layout.gap.medium
}));

export const SectionCaption = styled("p")(({ theme }) => ({
	...theme.project.typography.caption
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
	"& .MuiSelect-select": {
		padding: theme.project.layout.gutters.medium
	},
	"& .MuiOutlinedInput-root": {
		borderRadius: `${theme.project.borders.radius.small}px`
	},
	"& .MuiMenuItem-root": {
		padding: 0,
		width: "100%"
	}
}));

export const DeclineReasonMenuItem = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	width: "100%",
	boxSizing: "border-box"
}));

export const DeclineReasonTitle = styled("div")(({ theme }) => ({
	...theme.project.typography.menu.menuItem
}));

export const DeclineReasonDescription = styled("div")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	wordWrap: "break-word",
	whiteSpace: "normal"
}));

export const MessageContainer = styled("div")({
	position: "relative"
});

export const PlaceholderText = styled("div")(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary
}));
